import { render, staticRenderFns } from "./UserActivities.vue?vue&type=template&id=53e502b9&scoped=true"
import script from "./UserActivities.vue?vue&type=script&lang=js"
export * from "./UserActivities.vue?vue&type=script&lang=js"
import style0 from "./UserActivities.vue?vue&type=style&index=0&id=53e502b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e502b9",
  null
  
)

export default component.exports